export default "__VITE_ASSET__jomncfa6__"